import styled from 'styled-components';

const SessionContainer = styled.div.attrs(() => ({
  className: 'row',
}))`
  min-height: 100vh;
`;

export default SessionContainer;
